import { render } from "./ProductReview.vue?vue&type=template&id=256f9c0a&scoped=true"
import script from "../js/product-review.js?vue&type=script&lang=js"
export * from "../js/product-review.js?vue&type=script&lang=js"

import "./ProductReview.vue?vue&type=style&index=0&id=256f9c0a&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256f9c0a"]])

export default __exports__